import { useLocation, useNavigate, useParams } from "react-router-dom";
import { CREATE_QUOTE_PAGE_ROUTE } from "../routes";
import { useEffect, useState } from "react";
function usePolicyHighlightPage() {
  const { productRef, transferDataId, acuvisorProductId } = useParams();
  console.log("transferDataId in php: ", transferDataId);
  console.log("productRef in php: ", productRef);
  const { state } = useLocation();
  const { response } = state;

  const quickQuoteDetails = response?.quickQuoteDetails;
  console.log("Quick Quote Details", quickQuoteDetails);
  const policyDetails = response?.policyDetails?.[0];
  console.log("Policy Details", policyDetails);

  const [videoUrl, setVideoUrl] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    getVideoUrl();
  }, []);

  const getVideoUrl = () => {
    const videoUrlArray = policyDetails?.video_url?.split("/");
    // console.log(
    //   "kkk",
    //   videoUrlArray[videoUrlArray.length - 1].includes("watch")
    // );
    if (videoUrlArray?.[videoUrlArray.length - 1]?.includes("watch")) {
      let splitWatch = videoUrlArray?.[videoUrlArray.length - 1]?.split("=");
      setVideoUrl(splitWatch?.[splitWatch.length - 1]);
    } else {
      setVideoUrl(videoUrlArray?.[videoUrlArray.length - 1]);
    }
  };

  const handleOnBuyPlan = () => {
    let path = `${CREATE_QUOTE_PAGE_ROUTE}/${encodeURIComponent(
      productRef
    )}/${encodeURIComponent(transferDataId)}`;
    console.log(
      "encodeURIComponent(transferDataId): ",
      encodeURIComponent(transferDataId)
    );
    navigate(path);
  };

  const handleOnBack = () => {
    navigate(-1);
  };

  return {
    quickQuoteDetails,
    policyDetails,
    videoUrl,
    handleOnBuyPlan,
    handleOnBack,
  };
}

export default usePolicyHighlightPage;
